import React from 'react';

import commonFunctions from '../../../../commonFunctions';

import SelectInput from '../../../common/SelectInput';

/**
 * Used to manage this component in the BootstrapTable
 */
class WarrantyCoverageEditor extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            warrantyCoverageCapId: props.row.warrantyCoverageCapId
        };

        this.updateData = this.updateData.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    focus() {
    }

    onChange(event) {
        this.setState(Object.assign({}, this.state, { warrantyCoverageCapId: event.target.value }));
    }

    updateData() {
        this.props.onUpdate(this.state.warrantyCoverageCapId);
    }

    render() {
        let options = [];
        if (this.props.row.coverageCaps != null) {
            options = this.props.row.coverageCaps.map((value) => {
                return { value: value.id, text: commonFunctions.numberToItalianEuroFormat(value.coverageCap) };
            });
        }

        return (
            <center> <SelectInput
                name={'garanzia_' + this.state.warrantyId + '_warrantyCoverageCapId'}
                label=''
                value={this.state.warrantyCoverageCapId}
                defaultOptionText=''
                defaultOptionValue='-1'
                options={options}
                onChange={this.onChange} />
                <button
                    className='btn btn-info btn-xs textarea-save-btn'
                    onClick={this.updateData}>
                    Aggiorna </button>
            </center>
        );
    }
}

export default WarrantyCoverageEditor;